import styles from '../../estilos/inicioRegistro.module.css';

  
function AlertaErrorInicioSesion() {

  return(
    <div className={styles.containerAlerta} >
      <h1 className="my-5">¡Alerta!</h1>
      <h3 className='' >Error al iniciar sesión.</h3>
      <p className='mb-5 mt-2 mx-3' style={{textAlign: 'justify'}}  >Para iniciar sesión con google, debes sincronizarla primero. Ve a tu cuenta y haz click en sincronizar con google. Si ya lo hiciste, otro usuario tiene sincronizado este mismo correo de gmail. </p>
      <a className="btn btn-primary" href="/iniciar-sesion" role="button">Volver</a>
    </div>
  )
}


export default AlertaErrorInicioSesion;